import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';

import { Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

import { RangePickerService, RangeConfig, CalendarConfig } from '../../utils';

@Component({
    selector: '[aaRangeItem]',
    templateUrl: './range-item.component.html',
    styleUrls: [
        '../shared.scss',
        './range-item.component.scss'
    ],
    standalone: false
})
export class RangeItemComponent implements OnInit, OnDestroy
{
    @Input() showPanel: boolean;
    @Output() fromRangeItemShowCalendar: EventEmitter<boolean> = new EventEmitter<boolean>();
    private destroyator = new Subject();
    public displayRange: string;
    public cfg: CalendarConfig = new CalendarConfig();

    constructor(private rangePickerService: RangePickerService)
    {
    }

    ngOnInit ()
    {
        this.rangePickerService.config
            .pipe(
                tap((rc: RangeConfig) =>
                    this.setRange(rc)
                ),
                takeUntil(this.destroyator)
            )
            .subscribe();
    }

    ngOnDestroy ()
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    onClickArrow ()
    {
        this.showPanel = !this.showPanel;
        this.fromRangeItemShowCalendar.emit(this.showPanel);
    }

    private setRange (rc: RangeConfig)
    {
        if (rc.since !== null)
        {
            if (rc.until !== null)
            {
                const displayedSince: string = rc.since.toFormat(this.rangePickerService.format);
                const displayedUntil: string = rc.until.toFormat(this.rangePickerService.format);

                this.displayRange = `${rc.rangeItemFromTpl} ${displayedSince} ${rc.rangeItemToTpl} ${displayedUntil}`;
            } else
            {
                const displayedSince: string = rc.since.toFormat(this.rangePickerService.format);

                this.displayRange = `${rc.rangeItemFromTpl}/${rc.rangeItemToTpl} ${displayedSince}`;
            }
        } else
        {
            this.displayRange = '';
        }
    }
}
